import * as coreService from "@prismicio/editor-fields"

import { queryClient } from "../components/providers/QueryProvider"
import { env } from "../env"
import { getRepositoryName } from "../routing"

const envArgs = {
  repository: getRepositoryName(),
  authStrategy: env.PRISMIC_PAGE_BUILDER_AUTH_STRATEGY,
  baseUrl: env.PRISMIC_CUSTOM_TYPES_API_BASE_URL,
}

export function prefetchCustomTypes() {
  coreService.prefetchCustomTypes(queryClient, envArgs)
}

export function fetchCustomTypes() {
  return coreService.fetchCustomTypes(queryClient, envArgs)
}

export function useCustomTypes() {
  return coreService.useCustomTypes(envArgs)
}

export function useCustomType(id: string) {
  return coreService.useCustomType({
    id,
    ...envArgs,
  })
}

export function useStaticCustomType(id: string) {
  return coreService.useStaticCustomType({
    id,
    ...envArgs,
  })
}

export function usePrefetchStaticCustomType(id: string) {
  coreService.usePrefetchStaticCustomType({ id, ...envArgs })
}

export function invalidateCustomTypes() {
  return coreService.invalidateCustomTypes(queryClient, envArgs)
}
